import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      href="#top"
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-12 h-12 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 shadow-lg transition-all cursor-pointer"
    >
      <i className="ri-arrow-up-line text-xl w-6 h-6 flex items-center justify-center"></i>
    </a>
  );
}